import { exportExcel } from "@api/stores/productReports/exportExcel/api";
import { exportPDF } from "@api/stores/productReports/exportPDF/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IProductReportsGetAllParams,
  IProductReportsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IProductReportsResponse>>,
  IPathBaseParam,
  IPaginationParams & IProductReportsGetAllParams
>("stores.productReports");

export const productReports = {
  ...getAllApis,
  exportPDF,
  exportExcel,
};
